export default "__VITE_ASSET__BFIi7zmt__"